'use strict';

module.exports = (traits, ignoredKey) =>
  Object.keys(traits).reduce((notEmptyTraits, key) => {
    if (key !== ignoredKey && traits[key]) {
      notEmptyTraits[key] = traits[key]; // eslint-disable-line no-param-reassign
    }
    return notEmptyTraits;
  }, {});
